import {Fragment} from 'react';
import * as css from './Figures.css';

function Figures({items}: {items: {value: string; color: string; label: string}[]}) {
    return (
        <css.figures>
            {items.map((item, i) => (
                <Fragment key={item.label}>
                    {i > 0 && <css.figureDivider />}
                    <css.figure>
                        <css.figureVal>{item.value}</css.figureVal>
                        <css.figureLabel><css.dot $c={item.color} />{item.label}</css.figureLabel>
                    </css.figure>
                </Fragment>
            ))}
        </css.figures>
    );
}
export default Figures;
